import React from 'react'
import { Trans } from 'react-i18next'
import t from '../../../../../../translations/main'
import utils from 'src/components/Organisms/Form/utils'

import Font from 'src/components/Core/Typography/Font/Font'
import DropdownWrapper from 'src/views/Atoms/CountryDropdown/DropdownWrapper'

import { ConfigCompanyDetails } from '../../../CorporateAccount/CompanyDetails/types'

const PleaseFillText = (
  <Font
    key='pleaseFillText'
    ellipsis={false}
  >
    {/* @ts-ignore:next-line */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.TaxResidencyForm.modal.visualOnly.pleaseFill'} />
  </Font>
)

const IfTINavailableText = (
  <Font
    key='IfTINavailableText'
    ellipsis={false}
  >
    {/* @ts-ignore:next-line */}
    <Trans i18nKey={'onboarding.forms.IndividualAccount.TaxResidencyForm.visualOnly.ifTINavailable'} />
  </Font>
)

const config = ({ countries }: ConfigCompanyDetails) => utils.injectTranslation({
  id: 'TaxResidencyForm',
  path: 'onboarding.forms.IndividualAccount.TaxResidencyForm.inputs',
  content: [
    {
      componentType: 'grid',
      props: {
        rowGap: '16px'
      },
      content: [
        {
          componentType: '',
          visualComponent: PleaseFillText
        },
        {
          componentType: 'input',
          props: {
            name: 'countryOfResidence',
            required: true,
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: countries,
            name: 'countryOfResidence',
            label: 'onboarding.forms.IndividualAccount.TaxResidencyForm.modal.inputs.countryOfResidence.label',
            placeholder: 'onboarding.forms.IndividualAccount.TaxResidencyForm.modal.inputs.countryOfResidence.placeholder',
            bgTransparent: true,
            required: true,
            filter: true,
            ...props
          })
        },
      ],
    },
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'isTINAvailable',
            dataList: [
              {
                id: 'isTINAvailable1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'isTINAvailable2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        padding: '0 0 0 4%',
        boxSizing: 'border-box',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'tin',
            minHeight: '0',
            required: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        padding: '0 0 0 4%',
        boxSizing: 'border-box',
      },
      content: [
        {
          componentType: '',
          visualComponent: IfTINavailableText,
          visualName: 'ifTINavailableText',
        },
        {
          componentType: 'dropdown',
          props: {
            name: 'reason',
            minHeight: '0',
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'noTINReason',
            isTextarea: true,
            required: true,
            textAreaHeight: '90px',
            textAreaPointerEvents: 'auto'
          },
        },
      ],
    }
  ],
})

export default config
